
<mat-card class="example-card">
    <mat-card-header class="titreFrm">
        <mat-card-title>Cursus</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <div *ngIf="exist;else attente"></div>
        <ng-template #attente>
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>
        <mat-tab-group #tabGroupe [(selectedIndex)]="index" (animationDone)="animationDone()" (selectedTabChange)="tabChanged()">
            <mat-tab label="Cursus">
                <form class="example-form" #form="ngForm">
                    <div class="btn" >
                        <button (click)="enregistrerCursus(form)" [disabled]="disableBtnAjouter || disabled" mat-raised-button class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
                        <button (click)="goToListeCursus()" [disabled]="disabled" mat-raised-button class="colorGreen"><mat-icon>format_list_bulleted</mat-icon>Liste cursus</button>
                    </div>
                    <mat-card class="example-card carClass">
                        <mat-card-content>
                                
                            <mat-form-field  style="width: 80px;"   appearance="outline"  >
                                <mat-label>Identifiant</mat-label>
                                <input matInput disabled="true" name="Cursus_Code" #Cursus_Code="ngModel" [(ngModel)]="cursus.Cursus_Code"
                                placeholder="Identifiant" >
                            </mat-form-field>
                            <mat-form-field     appearance="outline"  >
                                <mat-label>Cursus</mat-label>
                                <input matInput [disabled]="disabled" type="text" name="Cursus_Titre" #Cursus_Titre="ngModel" [(ngModel)]="cursus.Cursus_Titre"
                                placeholder="Cursus" required>
                            </mat-form-field>
                            <mat-form-field     appearance="outline" style="width: 80px;" >
                                <mat-label>Durée</mat-label>
                                <input matInput [disabled]="disabled" type="number" name="Cursus_Duree" #Cursus_Duree="ngModel" [(ngModel)]="cursus.Cursus_Duree"
                                placeholder="Durée" required>
                            </mat-form-field>
                                   
                        </mat-card-content>
                       
                    </mat-card>
                </form>
            </mat-tab>
            <mat-tab label="Matière / Modules">
                <app-avt-matiere-cursus [disabled]="disabled" *ngIf="typeTrs != '1' && param_code != '' && param_code != null && param_code != undefined" [param_code]="param_code"></app-avt-matiere-cursus>
            </mat-tab>
        </mat-tab-group>
    </mat-card-content>
</mat-card>